import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import './SelectableData.scss'
import {
    LuxFormInput,
    LuxLoadingCircle,
    LUX_INPUT_TYPE,
} from '../../Techedge-Wardrobe'

const SelectableData = (props: {
    items: any[]
    setItems: (items: any[]) => void
    selectedItems: any[]
    setSelectedItems: (selectedItems: any[]) => void
    searchVal: string
    onChangeSearch: (newVal: string) => void
    loader: boolean
    labels?: {
        selectAll?: string
        itemsSelected?: string
        emptyMessage?: string
    }
    lazy?: boolean
    first?: number
    rows?: number
    rowsPerPageOptions?: number[]
    onChangePage?: (any) => void
    totalRecords?: number
}) => {
    const {
        items,
        setItems,
        selectedItems,
        setSelectedItems,
        searchVal,
        onChangePage,
        onChangeSearch,
        loader,
        labels,
        lazy,
        first,
        rows,
        rowsPerPageOptions,
        totalRecords,
    } = props

    const selectionHeader = (
        <div className="selectionHeader">
            <div
                style={{ cursor: 'pointer' }}
                onClick={() =>
                    setSelectedItems(
                        items?.length === selectedItems?.length ? [] : items
                    )
                }>
                {labels?.selectAll ? labels.selectAll : 'Select all'}
            </div>
            {selectedItems?.length > 0 && (
                <div className="itemsSelected">
                    {selectedItems.length}{' '}
                    {labels?.selectAll ? labels.selectAll : 'items selected'}
                </div>
            )}
        </div>
    )

    return (
        <div className="selectableData">
            <div className="selectableDataSearch">
                <LuxFormInput
                    value={[searchVal]}
                    type={LUX_INPUT_TYPE.text}
                    icon="search"
                    colWidth="auto"
                    placeholder="Search"
                    onChangeCallback={(e: any) => onChangeSearch(e)}
                />
            </div>
            {loader ? (
                <LuxLoadingCircle active={true} />
            ) : (
                <DataTable
                    dataKey="id"
                    value={items}
                    onPage={onChangePage}
                    selection={selectedItems}
                    lazy={lazy}
                    first={first}
                    rows={rows}
                    rowsPerPageOptions={
                        rowsPerPageOptions ? rowsPerPageOptions : [5, 10, 20]
                    }
                    onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    paginator
                    // paginatorTemplate={`CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown`}
                    paginatorTemplate={`CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink`}
                    currentPageReportTemplate="{first} - {last} of {totalRecords}"
                    totalRecords={totalRecords}
                    emptyMessage={
                        labels?.emptyMessage
                            ? labels.emptyMessage
                            : 'No stores to show.'
                    }>
                    <Column selectionMode="multiple" header={selectionHeader} />
                    <Column field="content" />
                </DataTable>
            )}
        </div>
    )
}

export default SelectableData
